const NotFound = () => {
  return <span className="text-xl">
    We're very sorry, it appears we couldn't find what you were looking for!
  </span>;
}

export default NotFound